import { render, staticRenderFns } from "./GridLinha.vue?vue&type=template&id=97f54edc&scoped=true&"
import script from "./GridLinha.vue?vue&type=script&lang=js&"
export * from "./GridLinha.vue?vue&type=script&lang=js&"
import style0 from "./GridLinha.vue?vue&type=style&index=0&id=97f54edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f54edc",
  null
  
)

export default component.exports